import { Address } from "web/types/address";
import { FieldData, fieldsAreEqual } from "web/types/form";
import { Name } from "web/types/name";

export interface BillingShippingInformation {
    address: Address;
    name: Name;
    phoneNumber: FieldData;
}

type Entries<T> = {
    [K in keyof T]: [K, T[K]];
}[keyof T][];

function typedEntries<T extends Record<string, any>>(obj: T): Entries<T> {
    return Object.entries(obj) as Entries<T>;
}

export function billingShippingAreEqual(
    primary: BillingShippingInformation,
    secondary: BillingShippingInformation
): boolean {
    const addressEntries = typedEntries<Address>(primary.address);
    const nameEntries = typedEntries<Name>(primary.name);

    const addressesEqual = addressEntries
        .map(([fieldName, data]) => fieldsAreEqual(data, secondary.address[fieldName]))
        .every((item) => item === true);
    const namesEqual = nameEntries
        .map(([fieldName, data]) => fieldsAreEqual(data, secondary.name[fieldName]))
        .every((item) => item === true);
    const phoneNumbersEqual = fieldsAreEqual(primary.phoneNumber, secondary.phoneNumber);

    return addressesEqual && namesEqual && phoneNumbersEqual;
}
